import { render, staticRenderFns } from "./TomHornFreespinsAssignForm.vue?vue&type=template&id=672b9839&"
import script from "./TomHornFreespinsAssignForm.vue?vue&type=script&lang=js&"
export * from "./TomHornFreespinsAssignForm.vue?vue&type=script&lang=js&"
import style0 from "./TomHornFreespinsAssignForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports